import type {
  ArrivalStatus,
  OrderStop,
  OrderSummary,
  TrailerTempSummary,
  TripStatus
} from '@asset-solutions/customer-portal/orders/models';
import { orderTempDeviation } from '@asset-solutions/customer-portal/orders/utils';

export class OrderSummaryVM {
  public completedStops = 0;
  public destination?: OrderStop;
  public nextStop?: OrderStop;
  public isAssigned = false;
  public orderMasterId = 0;
  public origin?: OrderStop;
  public remainingMilesToNextStop = 0;
  public remainingStops = 0;
  public shipmentDetails = {
    bolNumber: '',
    commodity: '',
    customerId: '',
    customerName: ''
  };
  public tmsOrderId = '';
  public tractor = {
    fleetId: '',
    tractorId: 0,
    tractorNumber: ''
  };
  public trailer: TrailerTempSummary = {
    lastUpdatedDate: '',
    returnAir1: Infinity,
    returnAir2: Infinity,
    returnAir3: Infinity,
    sensor1: Infinity,
    sensor2: Infinity,
    sensor3: Infinity,
    tempMax: 0,
    tempMin: 0,
    trailerId: ''
  };
  public tripStatus: TripStatus = 'Scheduled';

  // Create OrderSummaryVm from an OrderSummary
  static create(order: OrderSummary): OrderSummaryVM {
    return Object.assign(new OrderSummaryVM(), order);
  }

  get currentArrivalStatus(): ArrivalStatus {
    if (this.tripStatus === 'Scheduled' && this.origin) {
      return this.origin.stopArrivalStatus;
    }
    return this.nextStop?.stopArrivalStatus || 'ONTIME';
  }

  get hasTempDeviation(): boolean {
    const tempDeviation = orderTempDeviation(this.trailer);
    return tempDeviation.returnAir || tempDeviation.temps;
  }

  get isLate(): boolean {
    return this.currentArrivalStatus === 'LATE';
  }

  get issueText(): string {
    const textArr: string[] = [];
    if (this.hasTempDeviation) {
      textArr.push('Temp');
    }
    if (this.isLate) {
      textArr.push('Late');
    }
    return textArr.join('/');
  }

  get orderPriority(): number {
    // Convert isLate to 1 or 0, hasTempDeviation is weighted more so it is converted to 2 or 0
    return +this.isLate + (this.hasTempDeviation ? 2 : 0);
  }
}
